import React, {
  useState,
  useEffect,
  Suspense,
  useContext,
  useCallback,
} from "react";
import { getTrans as T } from "../../../../Shared/Language";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { postEmployeeFollow } from "../Services/DashboardServices";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import { TostMsg } from "../../../../App";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import InfiniteScroll from "react-infinite-scroll-component";
const ComponentLoader = React.lazy(() =>
  import("../../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";

function FollowUpSuggestionsList() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [followSuggestionListData, setFollowSuggestionListData] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [noData, setNoData] = useState([]);

  useEffect(() => {
    GetMasterSystemAlertList("Follower_Unavialable", 2);
    fetchEmployeeData();
    setPage(1);
  }, []);

  async function GetMasterSystemAlertList(message, type) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }

  //Get Employee List from EmployeeList service
  async function fetchEmployeeData() {
    setIsloading(true);
    let accumulatedData = [];
    let currentPage = page;
    let hasMoreData = true;
    try {
      while (accumulatedData.length < 10 && hasMoreData) {
        const params = {
          OrganisationId: userDetails?.OrgId,
          LoggedInEmployeeId: userDetails?.EmpId,
          IsDirectReportOrHierarchy: 0,
          SearchText: "",
          FollowersOnly: 0,
          FollowingsOnly: 0,
          IsExEmployeesAlso: 0,
          pageNumber: currentPage,
          pageSize: 10,
          EmployeeId: 0,
          IsSuggestedOnly: 0,
        };

        const employeesList = await getEmployeeList(params);
        if (!employeesList?.Data || employeesList.Data.length === 0) {
          hasMoreData = false;
          // break;
        }

        let FollowListData = employeesList.Data.filter(
          (emp) => emp.EmpId !== userDetails.EmpId
        ).filter((emp) => emp.IsFollowed === 0);
        FollowListData.sort(
          (a, b) =>
            (b.EmpId === userDetails?.EmpId) - (a.EmpId === userDetails?.EmpId)
        );

        accumulatedData = [...accumulatedData, ...FollowListData];
        currentPage++;
      }
      setIsloading(false);
      if (accumulatedData.length === 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
        setFollowSuggestionListData((data) => [...data, ...accumulatedData]);
        setPage(currentPage);
      }
    } catch (error) {
      console.error("fetchEmployeeData error:", error);
      toster.current.error(ERROR_LIST.DefaultError);
      setIsloading(false);
    }
  }

  async function PostEmployeeFollow(Id) {
    const updatedEmployeeFollowStatus = followSuggestionListData.map((emp) => {
      if (emp.EmpId === Id) {
        const isCurrentlyFollowed = emp.IsFollowed === 1;
        const currentCount = Number(emp.FollowersCount) || 0;
        const updatedFollowersCount = isCurrentlyFollowed
          ? currentCount - 1
          : currentCount + 1;
        return {
          ...emp,
          IsFollowed: isCurrentlyFollowed ? 0 : 1,
          FollowersCount: updatedFollowersCount,
        };
      }
      return emp;
    });
    setFollowSuggestionListData(updatedEmployeeFollowStatus);
    try {
      let params = {
        FollowerId: userDetails?.EmpId,
        EmpId: Id,
      };
      await postEmployeeFollow(params);
    } catch (error) {
      const revertedData = followSuggestionListData.map((emp) => {
        if (emp.EmpId === Id) return emp;
        return emp;
      });
      setFollowSuggestionListData(revertedData);
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  return (
    <div>
      <div>
        <div className="container-fluid">
          <div className="row g-3">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">{T("Follow Up Suggestions")}</h2>
              </div>
              <div>
                <Link to="/Dashboard">
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>{" "}
                    Back
                  </button>
                </Link>
              </div>
            </div>
            <InfiniteScroll
              dataLength={followSuggestionListData?.length}
              next={() => setTimeout(() => fetchEmployeeData(), 700)}
              hasMore={page > 1 && hasMore}
              scrollableTarget="scrollableDiv"
              style={{ overflow: "hidden" }}
            >
              <div className="row  g-3 mb-4">
                <div className="follows-uppage">
                  <ul className="list-group">
                    {followSuggestionListData.map((suggestion, index) => (
                      <li className="list-group-item d-flex align-items-center justify-content-between">
                        <Link
                          to={`/Profile/${suggestion.GUID}`}
                          className="d-flex align-items-center text-decoration-none"
                        >
                          <img
                            src={suggestion?.ProfileImage || defaultImage}
                            onError={handleImageError}
                            className="rounded-circle me-2"
                            width="32"
                            height="32"
                            alt=""
                          />
                          <div className="follow-up-box">
                            <span className="w-space-no text-truncate">
                              {suggestion?.FullName}
                            </span>
                            {suggestion?.CurrentDesignation && (
                              <p className="designation flex items-center gap-2 text-gray-700 font-medium mb-0">
                                <span className="fs-12">
                                  {suggestion?.CurrentDesignation}
                                </span>
                                <span className="text-gray-400"> | </span>
                                <span className="text-gray-500 fs-12">
                                  {suggestion?.CurrentDepartment}
                                </span>
                              </p>
                            )}
                            <span className="follow-span">
                             <span className="fs-12 text-primary me-2">
                                Follow : {suggestion?.FollowersCount}
                              </span>|&nbsp; <span className="fs-12 text-info me-2">
                                Following : {suggestion?.FollowingCount}
                              </span>
                            </span>
                            {/* <span className="ms-3 follow-span">
                              
                            </span> */}
                          </div>
                        </Link>
                        {userDetails?.EmpId !== suggestion?.EmpId && (
                          <>
                            {suggestion.IsFollowed === 0 ? (
                              <div
                                onClick={() =>
                                  PostEmployeeFollow(suggestion.Id)
                                }
                                className="follow-unfollow-member d-flex align-items-center justify-content-center"
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "auto",
                                }}
                                title="Follow"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-hand-thumbs-up-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z" />
                                </svg>
                              </div>
                            ) : (
                              <>
                                <div
                                  onClick={() =>
                                    PostEmployeeFollow(suggestion.Id)
                                  }
                                  className="follow-unfollow-member d-flex align-items-center justify-content-center"
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "auto",
                                  }}
                                  title="UnFollow"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    style={{
                                      color: "#ffffff",
                                      background: " #671cc9",
                                    }}
                                    fill="currentColor"
                                    className="bi bi-hand-thumbs-down-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M6.956 14.534c.065.936.952 1.659 1.908 1.42l.261-.065a1.38 1.38 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51q.205.03.443.051c.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.9 1.9 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.856 0-.29-.036-.586-.113-.857a2 2 0 0 0-.16-.403c.169-.387.107-.82-.003-1.149a3.2 3.2 0 0 0-.488-.9c.054-.153.076-.313.076-.465a1.86 1.86 0 0 0-.253-.912C13.1.757 12.437.28 11.5.28H8c-.605 0-1.07.08-1.466.217a4.8 4.8 0 0 0-.97.485l-.048.029c-.504.308-.999.61-2.068.723C2.682 1.815 2 2.434 2 3.279v4c0 .851.685 1.433 1.357 1.616.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.54.428 2.591" />
                                  </svg>
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </li>
                    ))}
                  </ul>
                  {followSuggestionListData.length === 0 && (
                    <div className="notfound">
                      <img src="/images/no-data-found/following.png" />
                      <p>{noData}</p>
                    </div>
                  )}
                </div>
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>

      {Isloading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default FollowUpSuggestionsList;
